import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  console.error('Failed to find the root element. The application cannot start.');
  document.body.innerHTML = `
    <div style="display: flex; align-items: center; justify-content: center; min-height: 100vh; background: #000; color: #fff; font-family: sans-serif; padding: 20px; text-align: center;">
      <div>
        <h1 style="font-size: 24px; margin-bottom: 16px;">Failed to Load Application</h1>
        <p style="color: #999;">The application could not start. Please try refreshing the page.</p>
      </div>
    </div>
  `;
} else {
  try {
    createRoot(rootElement).render(
      <StrictMode>
        <App />
      </StrictMode>
    );
  } catch (error) {
    console.error('Error rendering application:', error);
    rootElement.innerHTML = `
      <div style="display: flex; align-items: center; justify-content: center; min-height: 100vh; background: #000; color: #fff; font-family: sans-serif; padding: 20px; text-align: center;">
        <div>
          <h1 style="font-size: 24px; margin-bottom: 16px;">Application Error</h1>
          <p style="color: #999; margin-bottom: 8px;">An error occurred while loading the application.</p>
          <p style="color: #666; font-size: 14px;">Check the browser console for more details.</p>
        </div>
      </div>
    `;
  }
}
